import Vue from "vue";
import Vuex from "vuex";
import { RootState, AzureAdStatus } from "./types";
import { authentication } from "./authentication/index";
import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";
import VuexPersistence from "vuex-persist";
import { render } from "@/store/render";
import { logger } from "@/store/logger/index";
import { preview } from "@/store/preview/index";

Vue.use(Vuex);

const renderAuthentication = new VuexPersistence<RootState>({
    key: "render",
    storage: window.localStorage,
    modules: ["render"]
});

const persistAuthentication = new VuexPersistence<RootState>({
    key: "authentication",
    storage: window.localStorage,
    modules: ["authentication"]
});

const persistRoot = new VuexPersistence<RootState>({
    key: "root",
    storage: window.localStorage,
    reducer: (state) => ({
        allowStockImages: state.allowStockImages
    })
});

export default new Vuex.Store<RootState>({
    state: {
        reload: 1,
        azureAdStatus: {
            enabled: false,
            loaded: false
        } as AzureAdStatus,
        allowStockImages: false
    },
    modules: {
        authentication,
        render,
        preview,
        logger
    },
    mutations,
    actions,
    getters,
    plugins: [renderAuthentication.plugin, persistAuthentication.plugin, persistRoot.plugin]
});
